import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  makeStyles,
} from "@material-ui/core";
import moment from "moment";
import React, { useEffect } from "react";
import { sumCentsAmountToDolar } from "utils/tools";
import CommercialDocumentNoteInput from "./CommercialDocumentNoteInput";
import InvoiceInput from "./InvoiceInput";
import { useField } from "react-final-form";

const useStyles = makeStyles({
  table: {
    marginTop: "10px",
    minWidth: 650,
    padding: "1rem",
    marginBottom: "15px",
  },
});

interface ICcaCostPreviewProps {
  resultCalculations: IResultCcaCalculation[];
  paymentPercentages: IPaymentPercentage[];
  isCalculationButtonClicked: boolean;
}

interface InitializeCommercialDocumentsProps {
  result: IResultCcaCalculation;
  index: number;
}

const CcaCostPreview = ({
  resultCalculations,
  paymentPercentages,
  isCalculationButtonClicked,
}: ICcaCostPreviewProps) => {
  const classes = useStyles();
  const format = "DD/MM/YY";

  const InitializeCommercialDocuments = ({
    result,
    index,
  }: InitializeCommercialDocumentsProps) => {
    const commercialDocumentTagInvoiceMbcRef = useField(
      `ccaCommercialDocumentTags[${index}].invoiceMbcRef`
    );
    const commercialDocumentTagRateChartId = useField(
      `ccaCommercialDocumentTags[${index}].ccaRateChartId`
    );

    const commercialDocumentNoteField = useField(
      `ccaCommercialDocumentNotes[${index}].note`
    );
    const commercialDocumentNoteRateChartField = useField(
      `ccaCommercialDocumentNotes[${index}].ccaRateChartId`
    );

    useEffect(() => {
      if (isCalculationButtonClicked) {
        commercialDocumentTagInvoiceMbcRef.input.onChange(null);
        commercialDocumentTagRateChartId.input.onChange(result.ccaRateChart.id);

        commercialDocumentNoteField.input.onChange(null);
        commercialDocumentNoteRateChartField.input.onChange(
          result.ccaRateChart.id
        );
      }

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isCalculationButtonClicked]);

    return <></>;
  };

  return (
    <div style={{ marginTop: 35 }}>
      <Grid item xs={12}>
        <Typography variant="h5">
          CCA Cost Preview
        </Typography>
      </Grid>
      {resultCalculations.map(
        (resultCalculation: IResultCcaCalculation, index: number) => (
          <div key={`result-cca-${index}`}>
            <InitializeCommercialDocuments
              result={resultCalculation}
              index={index}
            />

            <Grid item xs={12}>
              <Typography variant="h6">
                Cost Preview for Rate Chart #
                {resultCalculation.ccaRateChart.id} -{" "}
                {resultCalculation.ccaRateChart.name}
              </Typography>

              {resultCalculation.transactions.length > 0 ? (
                <>
                  <TableContainer>
                    <Table className={classes.table} size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>Schedule Date</TableCell>
                          <TableCell>Amount</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {resultCalculation.transactions.map(
                          (item: IResultCalculationItem, key: number) => {
                            return (
                              <TableRow key={`transaction-cca-${key}`}>
                                <TableCell>
                                  {moment.utc(item.fromDate).format(format)} -{" "}
                                  {moment.utc(item.toDate).format(format)}
                                </TableCell>
                                <TableCell>
                                  $ {(item.total / 100).toFixed(2)}
                                </TableCell>
                              </TableRow>
                            );
                          }
                        )}

                        <TableRow>
                          <TableCell>Total :</TableCell>
                          <TableCell>
                            ${" "}
                            {sumCentsAmountToDolar(
                              resultCalculation.transactions
                            )}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>

                  <Grid item xs={4}>
                    <Typography variant="h6" gutterBottom>
                      Document Note
                    </Typography>
                    <CommercialDocumentNoteInput
                      label="Note"
                      source={`ccaCommercialDocumentNotes[${index}].note`}
                      rateChartSource={`ccaCommercialDocumentNotes[${index}].ccaRateChartId`}
                      rateChartId={resultCalculation.ccaRateChart.id}
                    />
                  </Grid>
                </>
              ) : (
                <Grid item xs={12}>
                  <Typography variant="h6">No Change in Cost.</Typography>
                </Grid>
              )}
            </Grid>

            {Number(sumCentsAmountToDolar(resultCalculation.transactions)) <
              0 &&
              paymentPercentages.length === 1 && (
                <div style={{ marginTop: 15 }}>
                  <Grid item xs={12}>
                    <Typography variant="h6" gutterBottom>
                      Tag Invoice
                    </Typography>
                  </Grid>

                  <Grid item xs={4}>
                    <InvoiceInput
                      label="Select Invoice"
                      source={`ccaCommercialDocumentTags[${index}].invoiceMbcRef`}
                      rateChartSource={`ccaCommercialDocumentTags[${index}].ccaRateChartId`}
                      rateChartId={resultCalculation.ccaRateChart.id}
                      creditNoteAmount={Math.abs(
                        Number(
                          sumCentsAmountToDolar(resultCalculation.transactions)
                        )
                      )}
                    />
                  </Grid>
                </div>
              )}
          </div>
        )
      )}
    </div>
  );
};

export default CcaCostPreview;
